const brlFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

const intFormatter = new Intl.NumberFormat("pt-BR", {
  maximumFractionDigits: 0,
});

export const fmtBRL = (v) => brlFormatter.format(v || 0);
export const fmtInt = (v) => intFormatter.format(v || 0);
